/**
 * กระบี่ปลายแท่งหมึก (pulse-seal): its lock routine (design docs/design/combat/2026-10-11-lock-moves-13.md §2.6, kit audit
 * docs/design/combat/2026-10-13-art-kit-audit.md piece 2). The lock move is sf-hold 定 (range 4, aim forced to lock: a ranged
 * lock by design). Identity: the caster never touches the foe — six finger-qi points marked from 2.6–3.2 m (`spacing`), a
 * stroke links them, one pluck releases all the damage. Contrast: the palm/sword routines are contact. Keys (sf* poses, ink
 * fx, finger/string sfx) are the contract for the motion / FX / sound lanes. Data only.
 */
import { registerLongMove } from './registry';

/** 定 นิ้วร้อยสายพิณ — six points sealed from range, linked with one stroke, plucked like a string. */
export const SIX_STRINGS = registerLongMove({
  skillId: 'sf-hold',
  kind: 'lock',
  name: 'นิ้วร้อยสายพิณ',
  opener: { type: 'contact', range: 0, tell: 0 },
  len: 5.0,
  catch: 0.4,
  power: 2.2,
  lunge: 0,
  spacing: [2.6, 3.2],
  beats: [
    { at: 0, pose: 'sfPointLeg', hits: 0, share: 0, foe: 'hit', fx: 'inkDot', sfx: 'fingerFlick', cam: 'hold' },
    { at: 0.4, pose: 'sfGlideL2', hits: 2, share: 0.12, foe: 'hit', ai: 2, fx: 'inkDot', sfx: 'fingerFlick2', cam: 'orbit' },
    { at: 1.3, pose: 'sfGlideR2', hits: 2, share: 0.12, foe: 'hit', ai: 2, fx: 'inkDot', sfx: 'fingerFlick3', cam: 'orbit' },
    { at: 2.1, pose: 'sfFront1', hits: 1, share: 0.08, foe: 'hit', fx: 'inkDot', sfx: 'fingerFlick4' },
    { at: 2.7, pose: 'sfLinkStroke', hits: 0, share: 0, foe: 'kneel', fx: 'meridianLink', sfx: 'brushDrag', cam: 'push' },
    {
      at: 3.5,
      pose: 'sfPluck',
      hits: 1,
      share: 0.68,
      foe: 'knock',
      dist: 1.2,
      stop: 0.08,
      fx: 'dotChainBurst',
      sfx: 'stringSnap',
      cam: 'shake',
    },
    { at: 4.2, pose: 'sfFold', hits: 0, share: 0, foe: 'fall' },
    { at: 4.6, pose: 'sfStance', hits: 0, share: 0, foe: 'recover' },
  ],
});
